import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const fetchRequiredOnboarding = productConfigurations => http.post('/eligibility-engine/v4/onboarding', {
  data: {
    productConfigurations
  }
});
export const GET_REQUIRED_ONBOARDING = registerQuery({
  fieldName: 'requiredOnboarding',
  args: ['earlyRequestName', 'productConfigurations'],
  fetcher({
    earlyRequestName,
    productConfigurations
  }) {
    return getEarlyRequestResult(earlyRequestName, () => fetchRequiredOnboarding(productConfigurations)).then(response => response.requiredOnboarding);
  }
});